import { FormTypography } from "@/forms-design-system/FormTypography";

export type ThemedItemTitleProps = {
  children: string;
};

export const ThemedItemTitle = ({ children }: ThemedItemTitleProps) => {
  return (
    <FormTypography variant="h6" fontWeight={700} vibe="intense" data-test="themed-item-block-rate-name">
      {children}
    </FormTypography>
  );
};
